// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"efeeb2d2","194":"1a69d54d","260":"f4f0bafe","725":"b53bbd02","786":"860075a8"}[chunkId] + ".chunk.js";
};